import { makeStyles } from '@material-ui/core'

export default makeStyles((theme) => ({
  ctaRoot: {
    margin: theme.spacing(4, 0),
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
  },
  link: {
    textDecoration: 'none',
    '& span': {
      fontSize: theme.typography.body1.fontSize,
      fontWeight: theme.typography.fontWeightRegular,
      color: theme.palette.text.mainAlternative,
      backgroundImage: `linear-gradient(120deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.main} 100%)`,
      backgroundRepeat: 'no-repeat',
      backgroundSize: '100% 0.2em',
      backgroundPosition: '0 110%',
      transition: 'background-size 0.25s ease-in',
      [theme.breakpoints.up('sm')]: {
        fontSize: theme.typography.body1.fontSize,
      },
    },
  },

  linkWrapper: {},

  btnWrapper: {
    marginBottom: theme.spacing(6),
  },

  linkButton: {
    background: theme.palette.primary.main,
    borderRadius: theme.spacing(0.5),
    color: 'white',
    padding: theme.spacing(2, 2.5),
    fontSize: theme.typography.body2.fontSize,
    fontWeight: theme.typography.fontWeightSemiBold,
    textTransform: 'uppercase',
    boxShadow: theme.shadows[0],
    textDecoration: 'none',
    [theme.breakpoints.up('md')]: {
      fontSize: theme.typography.body1.fontSize,
      '&:hover': {
        background: theme.palette.secondary.main,
      },
    },
  },
}))
